import { ReferencePickerContextType } from "../utils/analytics/analyticsLib093IssuesEvents";
import { TOOL_IDS } from "@adsk/alloy-provider";

export const ACTIVITY_VARIANTS = {
  ADDED: "added",
  REMOVED: "removed",
};

type ToolIds = typeof TOOL_IDS;
type ToolId = ToolIds[keyof ToolIds];

export const TOOL_ID_TO_RP_CONTEXT_TYPE: Partial<
  {
    [toolId in ToolId]: ReferencePickerContextType;
  }
> = {
  [TOOL_IDS.ASSETS]: "asset",
  [TOOL_IDS.DOCUMENTS]: "doc",
  [TOOL_IDS.FORMS]: "form",
  [TOOL_IDS.PHOTOS]: "photo",
  [TOOL_IDS.SHEETS]: "sheet",
};

export const VIRTUAL_ROW_HEIGHT = 48;
export const VIRTUAL_OVER_SCAN = 3;
export const ENTITIES_MAPPER_KEY = "id";
